import { gql } from '@apollo/client';
const REMOVE_PROJECTION_POINT_IMAGE = gql `
  mutation RemoveProjectionPointImage($projectionPointId: ID!) {
    removeProjectionPointPhoto(projectionPointId: $projectionPointId) {
      projectionPoint {
        id
        photo
        photoNumber
      }
    }
  }
`;
export default REMOVE_PROJECTION_POINT_IMAGE;
